import React from 'react';
import get from 'lodash/get';
import Checkbox from 'Common/Components/Checkbox';
import capitalize from 'lodash/capitalize';
import { Label, CheckboxWrapper } from './styled';

const BooleanField = ({
  defaultValue, param, parameters, onChangeField, isScheduler
}) => {
  const required = get(parameters, `${param}.mandatory`, false);
  const extractName = (str) => capitalize(str.replace('_', ' '));
  const type = get(parameters, `${param}.type`, false);

  return (
    <CheckboxWrapper key={ param } required={ required } isScheduler={ isScheduler }>
      <Checkbox state={ defaultValue } onChange={ (e) => onChangeField(param, !e.currentTarget.checked, type) } />
      <Label>{extractName(param)}</Label>
    </CheckboxWrapper>
  );
};
export default BooleanField;
